export { default, default as ForgotPasswordForm } from "./ForgotPasswordForm";
